import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useAgentStore, FALLBACK_LLM_MODELS } from '@/stores/agentStore';
import { useClickOutside } from '@/hooks/useClickOutside';

export const AgentModelSelector: React.FC = () => {
  const { currentModelId, setCurrentModel, availableModels, ensureAvailableModels } = useAgentStore();
  const [isOpen, setIsOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  // 点击下拉外部关闭（document 级监听）
  const closeMenu = useCallback(() => setIsOpen(false), []);
  useClickOutside([rootRef], closeMenu, isOpen);

  // 列表拉取收敛到 store 单飞：多组件挂载只发一次请求
  useEffect(() => {
    ensureAvailableModels();
  }, [ensureAvailableModels]);

  const models = availableModels.length > 0 ? availableModels : FALLBACK_LLM_MODELS;
  const currentModel = models.find((m) => m.id === currentModelId) || models[0];

  return (
    <div className="relative" ref={rootRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between text-white hover:bg-white/10 transition-colors"
        style={{
          backgroundColor: 'rgba(54, 54, 54, 0.25)',
          borderRadius: '8px',
          width: '188px',
          height: '32px',
          padding: '0 12px',
          fontSize: '14px',
          fontFamily: '"PingFang SC", sans-serif',
        }}
      >
        <span className="truncate">{currentModel?.name || 'Select Model'}</span>
        <img
          src="/icons/chevron-down.svg"
          alt=""
          width={16}
          height={16}
          className={`shrink-0 ml-2 transition-transform ${isOpen ? 'rotate-180' : ''}`}
          style={{ objectFit: 'contain' }}
          draggable={false}
        />
      </button>

      {isOpen && (
        <>
          <div
            className="absolute bottom-full left-0 mb-2 z-50 overflow-hidden"
            style={{
              width: '256px',
              backgroundColor: '#141414',
              border: '1px solid #2d2d2d',
              borderRadius: '16px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
            }}
          >
            {models.map((model) => (
              <button
                key={model.id}
                onClick={() => {
                  setCurrentModel(model.id);
                  setIsOpen(false);
                }}
                className="w-full text-left transition-colors"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '12px 16px',
                  backgroundColor: model.id === currentModelId ? '#2d2d2d' : 'transparent',
                }}
                onMouseEnter={(e) => { if (model.id !== currentModelId) e.currentTarget.style.backgroundColor = '#2d2d2d'; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = model.id === currentModelId ? '#2d2d2d' : 'transparent'; }}
              >
                <div>
                  <div style={{ fontSize: '14px', color: '#ffffff', fontFamily: '"PingFang SC", sans-serif', lineHeight: '20px' }}>
                    {model.name}
                  </div>
                  <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.45)', fontFamily: '"PingFang SC", sans-serif', lineHeight: '18px' }}>
                    {model.backend}
                  </div>
                </div>
                {model.id === currentModelId && (
                  <img src="/icons/check.svg" alt="选中" width={18} height={18} style={{ objectFit: 'contain', flexShrink: 0, marginLeft: '12px' }} draggable={false} />
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
